var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity } from '@decahedron/entity';
var AvatarAsset = /** @class */ (function (_super) {
    __extends(AvatarAsset, _super);
    function AvatarAsset() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.ownerId = null;
        _this.ownerType = null;
        _this.uploaderId = null;
        _this.fileName = null;
        _this.originName = null;
        _this.thumbnail = null;
        _this.label = null;
        _this.url = null;
        _this.source = null;
        _this.createdAt = null;
        return _this;
    }
    return AvatarAsset;
}(Entity));
export { AvatarAsset };
